import * as React from 'react';
import { forwardRef } from 'react';

export type DMTextProps = React.HTMLAttributes<HTMLElement> & {
  as?:
  | 'p'
  | 'span'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'label'
  | 'strong'
  | 'em';
};

export const DMText = forwardRef<HTMLElement, DMTextProps>(
  ({ className = '', as: Component = 'p', children, ...props }, ref) => {
    return (
      <Component ref={ref as any} className={className} {...props}>
        {children}
      </Component>
    );
  }
);
DMText.displayName = 'DMText';
